module.exports = __webpack_public_path__ + "static/media/dgsf-siegel-institute.01d84564.jpg";